

// Format any number as a percent
export function formatPercent(number, decimals, showPercent) {
  return (
    number !== null ? parseFloat(number * 100).toFixed(decimals) + (showPercent ? "%" : '') : '-'
  )
}

// Format any number
export function formatNumber(number, decimals) {
  return (
    number !== null ? parseFloat(number).toFixed(decimals) : '-'
  )
}

// Format any date
export function formatDate(dateString) {
  return (
    dateString && (new Date(dateString)).toLocaleDateString(undefined,
      {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }
    )
  )
}

// Format any time
export function formatTime(dateString) {
  return (
    dateString && (new Date(dateString)).toLocaleTimeString(undefined,
      {
        hour: '2-digit',
        minute: '2-digit'
      }
    )
  )
}
